module.exports = __webpack_public_path__ + "static/media/casino.8fbe2760.jpg";